import { MarketingEvent as e } from "./MarketingEvent.mjs";
import { z as t } from "zod";
//#region src/verticals/marketing/MarketingEventPayloads.ts
var n = t.object({
	popupId: t.string(),
	campaign: t.string().optional()
}), r = t.object({ popupId: t.string() }), i = t.object({
	bannerId: t.string(),
	destination: t.string()
}), a = t.object({
	listingId: t.string().uuid(),
	position: t.number().int().nonnegative()
}), o = t.object({ source: t.string().optional() }), s = {
	[e.PopupDisplayed]: n,
	[e.PopupDismissed]: r,
	[e.BannerClicked]: i,
	[e.FeaturedListingClicked]: a,
	[e.HomepageViewed]: o
};
//#endregion
export { s as MarketingEventSchemas };
